export const EventGalleryIMAGES = {
    "biz-bash-event-goa": {
        Meta_title: 'BIZ BASH EVENT - GOA | Marvel Blinds',
        Meta_OG_description: null,
        canonical_OG_url: `${process.env.REACT_APP_WEBSITE_URL}/events/biz-bash-event-goa`,
        pg_title: 'BIZ BASH EVENT – GOA',
        images: [
            "/Assets/Events/goa-bizbash1.jpg",
            "/Assets/Events/goa-bizbash2.jpg",
            "/Assets/Events/goa-bizbash3.jpg",
            "/Assets/Events/goa-bizbash4.jpg",
            "/Assets/Events/goa-bizbash5.jpg",
            "/Assets/Events/goa-bizbash6.jpg",
            "/Assets/Events/goa-bizbash7.jpg",
            "/Assets/Events/goa-bizbash8.jpg",
            "/Assets/Events/goa-bizbash9.jpg",
            "/Assets/Events/goa-bizbash10.jpg",
            "/Assets/Events/goa-bizbash11.jpg",
            "/Assets/Events/goa-bizbash12.jpg",
            "/Assets/Events/goa-bizbash13.jpg",
            "/Assets/Events/goa-bizbash14.jpg",
            "/Assets/Events/goa-bizbash16.jpg",
        ]
    },
    "achievers-mega-event-mumbai": {
        Meta_title: 'ACHIEVERS MEGA EVENT - MUMBAI | Marvel Blinds',
        Meta_OG_description: null,
        canonical_OG_url: `${process.env.REACT_APP_WEBSITE_URL}/events/achievers-mega-event-mumbai`,
        pg_title: 'ACHIEVERS MEGA EVENT – MUMBAI',
        images: [
            "/Assets/Events/mumbai-achiever1.jpg",
            "/Assets/Events/mumbai-achiever2.jpg",
            "/Assets/Events/mumbai-achiever3.jpg",
            "/Assets/Events/mumbai-achiever4.jpg",
            "/Assets/Events/mumbai-achiever5.jpg",
            "/Assets/Events/mumbai-achiever6.jpg",
            "/Assets/Events/mumbai-achiever7.jpg",
            "/Assets/Events/mumbai-achiever8.jpg",
            "/Assets/Events/mumbai-achiever9.jpg",
            "/Assets/Events/mumbai-achiever10.jpg",
            "/Assets/Events/mumbai-achiever11.jpg",
            "/Assets/Events/mumbai-achiever12.jpg",
            "/Assets/Events/mumbai-achiever13.jpg",
            "/Assets/Events/mumbai-achiever14.jpg",
            "/Assets/Events/mumbai-achiever15.jpg",
            "/Assets/Events/mumbai-achiever16.jpg",
        ]
    },
    "achievers-mega-event-goa": {
        Meta_title: 'ACHIEVERS MEGA EVENT - GOA | Marvel Blinds',
        Meta_OG_description: null,
        canonical_OG_url: `${process.env.REACT_APP_WEBSITE_URL}/events/achievers-mega-event-goa/`,
        pg_title: 'ACHIEVERS MEGA EVENT – GOA',
        images: [
            "/Assets/Events/goa-achiever1.jpg",
            "/Assets/Events/goa-achiever2.jpg",
            "/Assets/Events/goa-achiever3.jpg",
            "/Assets/Events/goa-achiever4.jpg",
            "/Assets/Events/goa-achiever5.jpg",
            "/Assets/Events/goa-achiever6.jpg",
            "/Assets/Events/goa-achiever7.jpg",
            "/Assets/Events/goa-achiever8.jpg",
            "/Assets/Events/goa-achiever9.jpg",
            "/Assets/Events/goa-achiever10.jpg",
            "/Assets/Events/goa-achiever11.jpg",
            "/Assets/Events/goa-achiever12.jpg"
        ]
    },
    "achievers-mega-event-lonavala": {
        Meta_title: 'ACHIEVERS MEGA EVENT - LONAVALA | Marvel Blinds',
        Meta_OG_description: null,
        canonical_OG_url: `${process.env.REACT_APP_WEBSITE_URL}/events/achievers-mega-event-lonavala/`,
        pg_title: 'ACHIEVERS MEGA EVENT – LONAVALA',
        images: [
            "/Assets/Events/lonavala1.jpg",
            "/Assets/Events/lonavala2.jpg",
            "/Assets/Events/lonavala3.jpg",
            "/Assets/Events/lonavala4.jpg",
            "/Assets/Events/lonavala5.jpg",
            "/Assets/Events/lonavala6.jpg",
            "/Assets/Events/lonavala7.jpg",
            "/Assets/Events/lonavala8.jpg",
            "/Assets/Events/lonavala9.jpg",
            "/Assets/Events/lonavala10.jpg",
            "/Assets/Events/lonavala11.jpg",
            "/Assets/Events/lonavala12.jpg",
            "/Assets/Events/lonavala14.jpg",
            "/Assets/Events/lonavala13.jpg",
            "/Assets/Events/lonavala15.jpg",
            "/Assets/Events/lonavala16.jpg"
        ]
    }
}